import 'libs/redactor/redactor';
import 'libs/redactor/source';
import 'libs/redactor/redactor.css';

import { RedactorDirectiveModule } from './redactor.directive';
import { RedactorAddLinkModalModule } from './components/addLinkModal.component';
import { RedactorEmbedVideoModalModule } from './components/embedVideoModal.component';

export const RedactorModule = angular
    .module('app.components.redactor', [
        RedactorDirectiveModule,
        RedactorAddLinkModalModule,
        RedactorEmbedVideoModalModule
    ]).name;



// WEBPACK FOOTER //
// ./src/app/components/redactor/redactor.module.js